// ── Notice ──────────────────────────────────────────────────────────────

/**
 * This file contains quick fixes for GSB core modules.
 * By using simple JS manipulation, we are able to prevent writing completely new element overrides.
 * This holds the advantage of benefitting from updates to GSB without having to take care of removing systematic overrides.
 * Depending on GSB's efforts, these workarounds might not be needed in the future.
 */

// ── Fixes ───────────────────────────────────────────────────────────────

/**
 * A function that adds the role="region" attribute to accordion content
 * This is needed as the content has a labelled by, but a generic role - resulting in a WCAG conflict.
 * This only applies to opened content, but remains an issue nonetheless.
 */
function fixAccordionRoles() {
  const selector: string = ".accordion .accordion-collapse";
  const elements: NodeListOf<HTMLDivElement> =
    document.querySelectorAll(selector);
  for (const element of elements) {
    element.setAttribute("role", "region");
  }
}

/**
 * A function to change the consent manager headline
 * This is needed as the current headline is H1, leading to a double h1 conflict on the page.
 */
function changeConsentMngrHeadline() {
  // Gather old element, quit if not present
  const headerClass: string = "consent-header";
  const selector: string = `h1.${headerClass}`;
  const element: HTMLHeadingElement | null = document.querySelector(selector);
  const parent = element?.parentElement;
  if (!element || !parent) return;
  const { textContent } = element;
  // Create and style new element, as stylings aren't 100% based on class
  const newElement = `<h2 class="${headerClass}" style="font-size: 32px" tabindex="-1">${textContent}</h2>`;
  parent.removeChild(element);
  parent.insertAdjacentHTML("afterbegin", newElement);
}

export function initQuickFixes() {
  fixAccordionRoles();
  changeConsentMngrHeadline();
}
